import { useEffect } from "react"

import { EventEmitter } from "@/domains/library"

interface EventHandlerProps<T> {
  emitter: EventEmitter<T>
  event: string | null
  handler: (event: string, data: T) => void
}

function useEventHandler<T>({ emitter, event, handler }: EventHandlerProps<T>): void {
  useEffect(() => {
    const eventName = event || "*"
    emitter.on(eventName, handler)

    return () => {
      emitter.off(eventName, handler)
    }
  }, [emitter, event, handler])
}

export default useEventHandler
